export default {
    selfInfo: null,
    detailPlace: null,
    partiesMes: null,
    fileList: null,
    fileImages: null,
    healthCard: null,
    searchValue: null
};
